import { render, staticRenderFns } from "./wizardStep.vue?vue&type=template&id=1ff4bfc8&scoped=true"
import script from "./wizardStep.vue?vue&type=script&lang=js"
export * from "./wizardStep.vue?vue&type=script&lang=js"
import style0 from "./wizardStep.vue?vue&type=style&index=0&id=1ff4bfc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff4bfc8",
  null
  
)

export default component.exports